import { render, staticRenderFns } from "./NewTransferAmountSelection.vue?vue&type=template&id=194f7540&scoped=true"
import script from "./NewTransferAmountSelection.vue?vue&type=script&lang=ts"
export * from "./NewTransferAmountSelection.vue?vue&type=script&lang=ts"
import style0 from "./NewTransferAmountSelection.vue?vue&type=style&index=0&id=194f7540&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194f7540",
  null
  
)

export default component.exports